export default "__VITE_ASSET__BRDMGfqX__"